import { defaultListParams } from 'src/common/filterTable/constants/defaultListParams';
import { cleanParams } from 'src/common/filterTable/helpers/cleanParams';
import { FilterFields } from '../types/FilterFields';
import { GetListParams } from '../types/GetListParams';

const useGetListParams = () => {
  const getListParams = (fields: FilterFields) => {
    const { orderId, creationTime, pfhNo, lastModifiedTime, creditCurrency } = fields;

    const { start: createdDateFrom, end: createdDateTo } = creationTime;
    const { start: lastModifiedDateFrom, end: lastModifiedDateTo } = lastModifiedTime;

    const params: GetListParams = {
      targetTransferOrderId: orderId,
      createdDateFrom,
      createdDateTo,
      lastModifiedDateFrom,
      lastModifiedDateTo,
      customerNumber: pfhNo,
      creditCurrency: creditCurrency?.currency,
      ...defaultListParams,
    };

    return cleanParams(params);
  };

  return { getListParams };
};

export default useGetListParams;
